import React from 'react';
import PropTypes from 'prop-types';
import defaults from '../theme';
import { deepMerge } from '../utils/util';

function Footer({
  caption,
  countCurr,
  countSeparator,
  countTotal,
  showCount,
  theme = {},
  ...props
}) {
  if (!caption && !showCount) return null;

  const mergedTheme = deepMerge(defaults, theme);
  const { color, gutter } = mergedTheme.footer;
  const { fontSize, color: countColor } = mergedTheme.footer.count;

  const imgCount = showCount ? (
    <div className={`text-[${countColor}] text-[${fontSize}] pl-4`}>
      {countCurr}
      {countSeparator}
      {countTotal}
    </div>
  ) : (
    <span />
  );

  return (
    <div
      className={`box-border flex justify-between items-center text-[${color}] cursor-auto line-height[1.3] px-[${gutter.horizontal}px] py-[${gutter.vertical}px]`}
      {...props}
    >
      {caption ? (
        <figcaption className="flex-1">{caption}</figcaption>
      ) : (
        <span />
      )}
      {imgCount}
    </div>
  );
}

Footer.propTypes = {
  theme: PropTypes.object,
  caption: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  countCurr: PropTypes.number,
  countSeparator: PropTypes.string,
  countTotal: PropTypes.number,
  showCount: PropTypes.bool,
};

export default Footer;
